import { useDispatch, useSelector } from 'react-redux';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import PendingLeadsContainer from './PendingLeadsContainer';
import PendingCard from '../PendingsCard';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPendingLeads } from '@/store/slices/components/dashboard/service';
import PendingLeadsEmptyState from './PendingLeadsEmptyState';
import {
  AGENT,
  BRANCH,
} from '@/components/FilterBar/constants/filtersConstants';
import { useTrackPendingTab } from '../../customHooks/useTrackDashboard';

function PendingLeads() {
  const dispatch = useDispatch();
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const track = useTrackPendingTab();
  const { count, loading, hasFetched, empty } = useSelector(
    (state) => state.DashboardSlice.pendingLeads
  );
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  useFetchOnViewport(
    (query) => {
      dispatch(getPendingLeads(query));
    },
    [],
    { hasFetched }
  );

  let urlRedirect = `${tokkoHost}/leads/`;
  if (selectedIds.length > 0) {
    const type = selectedIds[0].filter_type === AGENT ? AGENT : BRANCH;
    urlRedirect += `?${type}=[${selectedIds}]`;
  }
  if (!selectedIds.length) {
    urlRedirect += '?company_leads=true';
  }

  const leadsExpireText = `${count} ${Trans(
    translations,
    count === 1 ? 'LeadToExpire' : 'LeadsToExpire'
  )}`;

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={empty ? null : urlRedirect}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.pendingLeads(element)}
      >
        {leadsExpireText}
      </PendingCard.Header>
      {empty ? (
        <PendingLeadsEmptyState />
      ) : (
        <PendingLeadsContainer
          trackCallback={(element) => track.pendingLeads(element)}
        />
      )}
    </PendingCard>
  );
}

export default PendingLeads;
